import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { FlexContainer, Paragraph, CheckMark } from 'heliocor-ui'
import 'styled-components/macro'

import DragDrop from '../../../common/DragDrop/DragDrop'
import { SET_CAFE_STATUS } from '../../../store/cafe/actionTypes'


export const UploadDocument = ({
    documentConfig,
    handleUpload,
    canUpload = true,
    multiUpload = false,
    margin = '',
    containerMargin = '',
}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [firstImage, setFirstImage] = React.useState()

    const isCoreDocument = documentConfig.core
    const documentMaxSize = documentConfig.maxSize
    const documentExtensions = documentConfig.extensions
    const documentFilesToUpload = documentConfig.filesNumber

    const uploadedImages = firstImage ? 1 : 0
    const title = uploadedImages === 1 ? 'backUpload' : 'frontUpload'

    const onUploadStart= () => dispatch({ type: SET_CAFE_STATUS, cafeStatus: 'UPLOADING' })

    const onUploadEnd= () => dispatch({ type: SET_CAFE_STATUS, cafeStatus: 'READY' })

    const handleOnLoad = async (image, fileName, isCore) => {
        if(multiUpload && !firstImage) {
            setFirstImage(image)
            onUploadEnd()
        } else { 
            await handleUpload({
                isCore,
                fileName,
                image: firstImage || image,
                extraImage: documentFilesToUpload === 2 && image,
                selected: documentConfig
            })
        }
    }

    return(
        <FlexContainer column height='14rem' margin={containerMargin || '2rem'}>
            <DragDrop 
                onLoad={handleOnLoad}
                customTitle={multiUpload && title}
                customInfo={multiUpload && {
                    id: "filesUploaded", 
                    data: { uploadedDocs: uploadedImages, docsToUpload: documentFilesToUpload }
                }}
                margin={margin ? margin : '1rem 6rem'} 
                containerMargin={containerMargin}
                height='400px'
                fontSize='1rem'
                clickable={canUpload}
                fileTypes={documentExtensions}
                isCore={isCoreDocument}
                filesNumber={documentFilesToUpload}
                canUpload={canUpload}
                limitSize={documentMaxSize}
                onUploadStart={onUploadStart}
                content={!canUpload ? (
                    <FlexContainer column alignItems="center" justifyContent="center">
                        <CheckMark size="30" fill="aqua100"/>
                        <Paragraph css="text-align: center;" value={t('warning.allFilesUploaded')} />
                    </FlexContainer>
                ) : null}
            />
        </FlexContainer>
    )
}
